export default function () {
  // this.doLoad()
  this.checkDomainOperator()
  this.getAllCities()
  this.getAllSpecialities()
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/gadget/resources/mounted.js